<template>
  <v-dialog
    v-model="openaiDialogShow"
    max-width="75%"
  >
    <template v-slot:activator="{}">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="buttonType === 'check'"
            class="mx-2"
            :color="buttonClass()"
            :loading="loading"
            v-bind="attrs"
            v-on="on"
            icon
            small
            @click="openDialog"
            :disabled="buttonDisabled"
          >
            <v-icon>mdi-check-bold</v-icon>
          </v-btn>
          <v-btn
            v-else
            class="mx-2"
            :color="buttonClass()"
            :loading="loading"
            fab
            small
            @click="openDialog"
            :disabled="buttonDisabled"
          >
            <span
              class="font-weight-bold"
              v-bind="attrs"
              v-on="on"
              :style="{color: 'white'}"
            >VI</span>
          </v-btn>
        </template>
        Content tags
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Content Tags: {{ poi.name ? poi.name : '' }}</span>
      </v-card-title>

      <v-card-text height="80%">
        <div class="py-3">
          <div class="d-flex">
            <v-spacer></v-spacer>
            <v-btn @click="updateContentTags" color="primary">
              <span class="pr-2">Update Content Tags By Videos</span>
            </v-btn>
          </div>
        </div>
        <v-row>
          <v-col>
            <v-card>
              <v-card-title>All available</v-card-title>
              <v-card-text class="tag-list">
                <v-list-item
                  v-for="(element) in contentTags"
                  :key="element.id"
                  v-show="!poi_content_tags.some(el => el.name === element.name)"
                  @click="addTag(element.name)"
                >
                  <v-chip link>{{ element.name }}</v-chip>
                </v-list-item>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col>
            <v-card>
              <v-card-title>
                Selected by AI
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="black"
                      class="mx-2"
                      v-bind="attrs"
                      v-on="on"
                      dark
                      icon
                      small
                      @click="show_all_labels = !show_all_labels"
                    >
                      <v-icon>mdi-eye-outline</v-icon>
                    </v-btn>
                  </template>
                  Show all video labels
                </v-tooltip>
              </v-card-title>
              <v-card-text class="tag-list">
                <v-list-item
                  v-for="(element) in video_labels"
                  :key="element.id"
                  v-show="element.contentTag &&
                  !poi_content_tags.some(el => el.name === element.contentTag.name)"
                  @click="addTag(element.contentTag.name)"
                >
                  <v-chip link>
                    {{ element.name }} ({{ element.contentTag ? element.contentTag.name : '' }})
                  </v-chip>
                </v-list-item>
                <div v-if="show_all_labels">
                  <v-list-item
                    v-for="(element) in video_labels"
                    :key="element.id"
                    v-show="!element.contentTag"
                  >
                    <v-chip color="yellow">{{ element.name }}</v-chip>
                  </v-list-item>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col>
            <v-card>
              <v-card-title>Confirmed</v-card-title>
              <v-card-text class="tag-list">
                <v-list-item
                  v-for="(element) in poi_content_tags"
                  :key="element.name">
                  <v-chip close @click:close="deleteTag(element)">{{ element.name }}</v-chip>
                </v-list-item>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="closeDialog"
        >
          Cancel
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click="saveData"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ContentTags',
  props: {
    poiData: {
      type: Object,
      default() {
        return {};
      },
    },
    poiId: {
      type: Number,
      default: null,
    },
    contentTags: {
      type: Array,
      default() {
        return [];
      },
    },
    triggerRun: {
      type: Number,
      default: 0,
    },
    buttonType: {
      type: String,
      default: 'ai',
    },
    buttonDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    poi: {},
    openaiDialogShow: false,
    loading: false,
    video_labels: [],
    poi_content_tags: [],
    show_all_labels: false,
  }),

  created() {
    if (Object.keys(this.poiData).length) {
      this.initData(this.poiData);
    }
  },

  methods: {
    ...mapActions({
      setSnack: 'snackbar/setState',
    }),

    openDialog() {
      if (Object.keys(this.poi).length) {
        this.openaiDialogShow = true;
      } else if (Object.keys(this.poiData).length) {
        this.initData(this.poiData);
      } else {
        this.$requestHelpers
          .get(`api/admin/poi/${this.poiId}`)
          .then((response) => {
            this.initData(response.data);
          });
      }
      this.openaiDialogShow = true;
    },

    closeDialog() {
      this.openaiDialogShow = false;
      this.poi_content_tags = JSON.parse(JSON.stringify(this.poi.content_tags));
    },

    initData(data) {
      this.poi = data;
      this.prepareLabels(data.videos);
      this.poi_content_tags = JSON.parse(JSON.stringify(this.poi.content_tags));
    },

    buttonClass() {
      let buttonClass = 'primary';

      if (this.poiData.content_tags.length) {
        buttonClass = 'green';
      }

      return buttonClass;
    },

    updateContentTags(withOverlay = true) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$requestHelpers
        .post(
          `api/admin/poi/update-content-tags/${this.poi.id}`,
          {},
          {
            withOverlay,
          },
        )
        .then((response) => {
          this.prepareLabels(response.data.result.videos);
          this.poi_content_tags = JSON.parse(JSON.stringify(response.data.result.content_tags));
          this.$emit('updatePoiData', response.data.result);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    addTag(tag) {
      if (!this.poi_content_tags.some((el) => el.name === tag)) {
        this.poi_content_tags.push({ name: tag });
      }
    },

    deleteTag(tag) {
      this.poi_content_tags = this.poi_content_tags.filter((el) => el.name !== tag.name);
    },

    saveData() {
      const data = {
        content_tags: this.poi_content_tags,
      };

      this.$requestHelpers
        .patch(`api/admin/poi/${this.poi.id}`, data)
        .then((response) => {
          if (response.data.success) {
            this.initData(response.data.result);
            this.setSnack({
              color: 'green',
              text: 'saved',
            });
            this.row = '';
            this.openaiDialogShow = false;
            this.$emit('updatePoiData', response.data.result);
          }
        });
    },

    prepareLabels(videos) {
      const labels = [];
      videos.forEach((video) => {
        video.labels.forEach((label) => {
          if (!labels.some((el) => el.name === label.name)) {
            labels.push({ id: label.id, name: label.name, contentTag: label.content_tag });
          }
        });
      });
      // eslint-disable-next-line no-nested-ternary
      labels.sort((a, b) => ((a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)));
      this.video_labels = labels;
    },
  },
  watch: {
    triggerRun() {
      this.updateContentTags(false);
    },
    poiData: {
      handler(newValue) {
        this.initData(newValue);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.tag-list {
  overflow-y: auto;
  height: 300px;
}
</style>
